import React, { useState } from "react";
import { FaBars, FaSignOutAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import useAuth from "../services/hooks/useAuth";
import "./Navigation.css";

const Navigation = () => {
  const { isAuthenticated, logout } = useAuth();
  const [showNav, setShowNav] = useState(false);

  const toggleNav = () => {
    setShowNav((prev) => !prev);
  };

  const hideNav = () => {
    setShowNav(false);
  };

  if (!isAuthenticated()) {
    return null;
  }

  return (
    <React.Fragment>
      <div className="navigation-toggler" onClick={() => toggleNav()}>
        <FaBars />
      </div>
      <nav className={showNav ? "nav-show" : ""}>
        <ul>
          <li>
            <Link to="/" onClick={() => hideNav()}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/swipes" onClick={() => hideNav()}>
              Swipes
            </Link>
          </li>
          <li>
            <Link to="/swipe/check" onClick={() => hideNav()}>
              Check
            </Link>
          </li>
          <li>
            <Link to="/map" onClick={() => hideNav()}>
              Karte
            </Link>
          </li>
          <li>
            <Link to="/taggroups" onClick={() => hideNav()}>
              Taggruppen
            </Link>
          </li>
          <li>
            <Link to="/images" onClick={() => hideNav()}>
              Bilder
            </Link>
          </li>
          <li>
            <Link to="/images/crop" onClick={() => hideNav()}>
              Zuschneiden
            </Link>
          </li>
          <li>
            <Link to="/suggest-changes" onClick={() => hideNav()}>
              Änderungsvorschläge
            </Link>
          </li>
          <li>
            <Link to="/admin" onClick={() => hideNav()}>
              Admin
            </Link>
          </li>
          <li>
            <Link to="#" onClick={() => logout()}>
              <FaSignOutAlt />
            </Link>
          </li>
        </ul>
      </nav>
    </React.Fragment>
  );
};

export default Navigation;
